import type {
  ConfigurationParameters,
  Middleware,
  RequestContext,
} from "@freightsimple/generated-dashboard-openapi-client/runtime";
import { v4 as uuidv4 } from "uuid";
import { apiServerUrl } from "@/Environment";
import { rateLimitRetryMiddleware } from "@/Helpers/rateLimitRetryMiddleware";
import { unauthorizedResponseMiddleware } from "@/Helpers/unauthorizedResponseMiddleware";

function generateW3CTraceParent(): string {
  const version = "00";
  const traceId = uuidv4().replace(/-/g, "");
  const spanId = uuidv4().replace(/-/g, "").slice(0, 16);
  const flags = "01"; // Sampled

  return `${version}-${traceId}-${spanId}-${flags}`;
}

// Create a new type with required basePath
type RequiredBasePathConfig = ConfigurationParameters & {
  basePath: string; // This overrides the optional basePath?: string from ConfigurationParameters
};

export function getConfig(): RequiredBasePathConfig {
  return {
    basePath: apiServerUrl(),
    middleware: [
      {
        pre: async (context: RequestContext): Promise<RequestContext> => {
          // Headers accepts any HeadersInit shape, so no cast is needed to
          // add the custom header
          const headers = new Headers(context.init.headers);
          headers.set("traceparent", generateW3CTraceParent());
          context.init.headers = headers;
          return context;
        },
      } as Middleware,
      rateLimitRetryMiddleware(),
      unauthorizedResponseMiddleware(),
    ],
  };
}
